/* <checkbox-limit data-max="6">: once the limit is reached, the unchecked boxes are disabled and the
   live count says so (samples request, §11.5). Without JS the form still submits normally. */
class CheckboxLimit extends HTMLElement {
  connectedCallback() {
    this.max = Number(this.dataset.max) || 0;
    this.status = this.querySelector('[data-limit-status]');
    this.onChange = () => this.sync();
    this.addEventListener('change', this.onChange);
    this.sync();
  }

  sync() {
    const boxes = [...this.querySelectorAll('input[type="checkbox"]')];
    const checked = boxes.filter((box) => box.checked).length;
    boxes.forEach((box) => {
      if (!box.checked) box.disabled = this.max > 0 && checked >= this.max;
    });
    if (this.status && this.dataset.status) {
      this.status.textContent = this.dataset.status.replace('[n]', checked).replace('[max]', this.max);
    }
  }
}

if (!customElements.get('checkbox-limit')) customElements.define('checkbox-limit', CheckboxLimit);
